// Org-level gate for the Department Report feature (ISOLATED MODULE).
//
// Rolled out per-organization. Until an org's ID is in DEPT_REPORT_ENABLED_ORGS,
// no user in that org sees the "Department Report" tab — even admins.
//
// To enable for a new org: add the orgId string here, deploy. Single source of
// truth, no env var, auditable in git history.

const DEPT_REPORT_ENABLED_ORGS = new Set([
  '6a158e92ecba51bec473b1c8', // MARKET RESEARCH FUTURE (musaib.shaikh@marketresearchfuture.com)
]);

/** Is the Department Report feature enabled for this org? */
export function isDeptReportEnabledForOrg(orgId) {
  if (!orgId) return false;
  return DEPT_REPORT_ENABLED_ORGS.has(String(orgId));
}

/**
 * Should this specific user see the Department Report tab?
 * - Org must be enabled (allowlist above)
 * - User must be org_admin or main_admin
 */
export function canUserAccessDeptReport(user) {
  if (!user) return false;
  const orgId = user.organizationId?._id || user.organizationId;
  if (!isDeptReportEnabledForOrg(orgId)) return false;
  return user.role === 'org_admin' || user.role === 'main_admin';
}
